<template>
	<header class="topo topo--desktop" ref="$el">
		<div class="topo__inner">
			<div class="container">
				<div class="logo">
					<slot name="logo"></slot>
				</div><!--/.logo-->

				<div class="topo__faixa" ref="$topoFaixa">
					<slot name="redes-sociais" />
					<slot name="telefones" />
				</div><!--/.topo__faixa-->

				<slot name="menu" />

			</div><!--/.container-->
		</div><!--/.topo__inner-->
	</header>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const $topoFaixa = ref(null)
const $el = ref(null)

function setPadding() {
	$el.value.style.setProperty('--offset', `${$topoFaixa.value.offsetHeight}px`)
}

onMounted(() => {
	setPadding()

	window.addEventListener('resize', setPadding)
})
</script>
